import store from "@/store";
import * as fromAuth from "@/store/auth";
import * as fromMatch from "@/store/match";
import { NavigationGuard } from "vue-router";
import { User } from "../models/auth.model";
import { AuthMutationTypes } from "./../store/auth/auth.mutations";
import { canNavigateToMatchEdit } from "./helpers/guard.helper";
import * as Sentry from "@/utils/logger.util";

export const authGuard: NavigationGuard = (to, from, next) => {
  if (store.getters[`${fromAuth.namespaceAuth}/isLoggedIn`]) next();
  else next({ path: "/auth/login", query: { redirect: to.fullPath } });
};

export const adminGuard: NavigationGuard = (to, from, next) => {
  if (store.getters[`${fromAuth.namespaceAuth}/isAdmin`]) next();
  else next({ path: "/", query: { redirect: to.fullPath } });
};

export const editMatchGuard: NavigationGuard = async (to, from, next) => {
  const user = await getUser();

  if (!user) {
    next(from.path);
  } else {
    const matchState = (store.state as fromMatch.RootState).match;

    try {
      const match =
        matchState.match ||
        (await store.dispatch(`${fromMatch.namespaceMatch}/${fromMatch.MatchActionTypes.FetchMatch}`, Number.parseInt(to.params["id"])));

      canNavigateToMatchEdit(user, match) ? next() : next(from.path);
    } catch (error) {
      Sentry.captureException(error);
      next(from.path);
    }
  }
};

const getUser = () =>
  new Promise<User | null>(resolve => {
    const { user, token } = (store.state as fromAuth.RootState).auth;

    if (user) resolve(user);
    else {
      if (token) {
        store.subscribe(async mutation => {
          if (mutation.type === `${fromAuth.namespaceAuth}/${AuthMutationTypes.SetUser}`) {
            resolve(mutation.payload);
          }
        });
      } else {
        resolve(null);
      }
    }
  });
